const NoSessionIdScreen = () => {
  return (
    <div className='dashboard-home'>
      <div className='dashboard-header'>
        <div className='title-section'>
          <h1 className='dashboard-title'>Please provide a valid session id</h1>
        </div>
      </div>
    </div>
  );
};

export default NoSessionIdScreen;
